export default __webpack_public_path__ + "static/media/hot-summer.ad949ec0.svg";